import { Haemoglobin } from "@cur8/health-risks-calc";
import { PathLink } from "@pomle/react-router-paths";
import { usePatientQuery } from "render/hooks/api/queries/usePatientQuery";
import { paths } from "render/routes/paths";
import { getMetricHistory } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/metrics/utils/getMetricHistory";
import { useHaemoglobinMetric } from "render/views/Report/AppointmentDataView/components/MetricsSection/hooks/usePatientReportMetrics";
import { Metric, MetricLoading } from "../../layouts/Metric";
import { Trans } from "./trans";

export function MetricHaemoglobin() {
  const { data: patient, isLoading: isPatientLoading } = usePatientQuery();
  const { data, isLoading: isDataLoading } = useHaemoglobinMetric();

  if (isPatientLoading || isDataLoading) {
    return <MetricLoading label={<Trans.MetricName />} />;
  }

  if (!data || !patient) {
    return null;
  }

  const { cur, prev } = getMetricHistory(data);
  const riskRanges = Haemoglobin.rangesFor({ sex: patient.sex });
  const metricRating = cur && riskRanges.findRisk(cur.unit);
  const value = cur?.unit["g/L"];
  const prevValue = prev?.unit["g/L"];

  return (
    <PathLink to={paths.haemoglobinMetric.url({})}>
      <Metric
        label={<Trans.MetricName />}
        metricRating={metricRating}
        value={value}
        subLabel="g/L"
        previousValue={prevValue}
      />
    </PathLink>
  );
}
